import React, { FC } from "react";
import LogoLArge from "shared/Logo/LogoLarge";
import MenuBar from "shared/MenuBar/MenuBar";
import AvatarDropdown from "./AvatarDropdown2";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import texture from "images/bg_Texture5.png";
import { useAuth0 } from "@auth0/auth0-react";


export interface MainNav3Props {
  className?: string;
}

const MainNav3: FC<MainNav3Props> = ({ 
    className = "",
}) => {
    const { loginWithRedirect, logout } = useAuth0();
    
    function gotoLogin() {
      }
  
      const handleButtonClick = () => {
        window.location.href = "https://blog.paradiseliving.homes/"; 
      };

    const logoutWithRedirect = () =>{
       logout({ logoutParams: { returnTo: window.location.origin }})
    };

    const {user, isAuthenticated} = useAuth0();

   

  return (
    <div className="relative">
      <div className={`absolute left-0 top-0  ${className} opacity-50  w-full  h-[97px] z-0`} style={{
        backgroundImage: `url(${texture})`, 
        backgroundSize: 'auto', 
        backgroundRepeat: 'repeat', 
        }}>
     </div>
        <div className="ml-[70px] mr-[100px] py-4 lg:py-5 relative flex justify-between items-center"> 
            <div className="hidden md:flex justify-start flex-1 items-center space-x-3 sm:space-x-8 lg:space-x-10">
            <div className="flex justify-center md:pl-[70px] flex-1 pl-[10px]"> 
                <LogoLArge />
            </div>
            </div>

            <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
            <HeroSearchForm2MobileFactory />
            </div>

            <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700">
         
             <button className="text-sm font-semibold " onClick={handleButtonClick}>BLOG</button>
             <button className="text-sm font-semibold  px-[35px]" >ABOUT US</button>

            { !isAuthenticated && <button className="bg-[#00D3DB] rounded-md h-7 text-sm font-semibold text-[white] px-[19px]" onClick={() => loginWithRedirect()}>Log In</button>}
            { isAuthenticated && <AvatarDropdown logoutClick={logoutWithRedirect} />}

            <MenuBar />
            </div>
        </div>

</div>
  );
};

export default MainNav3;